import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";
import { requireExhaustive } from "../../shared/src/util";

export const CaseComplianceRaiseType = union([
    literal("sar"),
    literal("raised_with_pi_insurers"),
]);
export type TCaseComplianceRaiseTypeCodec = typeof CaseComplianceRaiseType;
export type TCaseComplianceRaiseType = TTypeOfCodec<TCaseComplianceRaiseTypeCodec>;

export const getCaseComplianceRaiseTypeDisplayString = (type: TCaseComplianceRaiseType): string => {
    if (type === "sar") { return "SAR"; }
    else if (type === "raised_with_pi_insurers") { return "Raised with insurers"; }
    else { return requireExhaustive(type); }
};
